import { computed, useContext } from '@nuxtjs/composition-api'
import CollectionType from '@/enums/CollectionType'

type Dictionary<T> = { [key: string]: T }
export const parseTypeParams = (params: Dictionary<string>) => {
  let _type = params.type
  const suffix = '-car-rental'
  if (_type.endsWith(suffix)) _type = _type.slice(0, _type.length - suffix.length)
  if (!Object.values(CollectionType)?.includes(_type as CollectionType)) {
    return null
  }
  return _type as CollectionType
}

export default function () {
  const { params } = useContext()

  const type = computed(() => {
    return parseTypeParams(params.value)
  })

  const query = computed(() => {
    const _query: { [key: string]: any } = {}

    switch (type.value) {
      case CollectionType.COMPACT:
        _query.carType = 1
        break
      case CollectionType.MULTI_SEATER:
        _query.seats = '8,'
        break
      case CollectionType.SPORTS_CAR:
        _query.carType = 5
        break
      case CollectionType.TESLA:
        _query.brand = 40
        break
      case CollectionType.VOLVO:
        _query.brand = 30
        break
      case CollectionType.WELCAB:
        _query.carType = 6
        break
      case CollectionType.RV:
        _query.carType = 8
        break
    }
    return _query
  })

  return {
    type,
    query,
  }
}
